import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const AuthContext = createContext(null);
const API = "https://simta-production.up.railway.app/api";

// Interceptor global — tambah Authorization header ke SEMUA request axios
axios.interceptors.request.use(config => {
  config.withCredentials = false; // override withCredentials agar tidak blokir CORS
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

function formatError(detail) {
  if (detail == null) return "Terjadi kesalahan. Coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(e => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (!token) { setUser(null); return; }
    axios.get(`${API}/auth/me`)
      .then(res => setUser(res.data))
      .catch(() => {
        localStorage.removeItem("access_token");
        setUser(null);
      });
  }, []);

  const login = async (identifier, password) => {
    try {
      const { data } = await axios.post(`${API}/auth/login`, { identifier, password });
      const { access_token, ...userInfo } = data;
      localStorage.setItem("access_token", access_token);
      setUser(userInfo);
      return userInfo;
    } catch (e) {
      throw new Error(formatError(e.response?.data?.detail) || e.message);
    }
  };

  const logout = async () => {
    localStorage.removeItem("access_token");
    setUser(null);
  };

  const register = async (formData) => {
    try {
      const { data } = await axios.post(`${API}/auth/register`, formData);
      const { access_token, ...userInfo } = data;
      localStorage.setItem("access_token", access_token);
      setUser(userInfo);
      return userInfo;
    } catch (e) {
      throw new Error(formatError(e.response?.data?.detail) || e.message);
    }
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, register, API }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export { API };
